import React from 'react';
import ReactDOM from 'react-dom';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import MyDocument from './MyDocument';
import Header from './Header';
import "../css/ViewPDFFile.css";
import { useLocation } from "react-router-dom";
import ic_blue_cube from "../img/ic_blue_cube.png";

const ViewPDFFile = (props) => {

    const location = useLocation();
    console.log(" location data in order taking", location.state?.data.data_set_from_parent);
    console.log(" invoiceFromParent in order taking", location.state?.data.invoiceFromParent);
    console.log("location.state?.data.customerCode ", location.state?.data.customerCode);


    return (

        <div className="ViewPDFFile-root-container">

            <div className="PreviousOrderDetailPage-layer-1">
                <img src={ic_blue_cube} />
            </div>

            <div className="PreviousOrderDetailPage-layer-2 pb-4">

                <Header />

                <div className='ViewPDFFile-inner-container mt-3' >
                    <div suppressHydrationWarning={true}>
                        {location.state != null ?
                         <PDFDownloadLink document={<MyDocument listOfStatement={location.state?.data.data_set_from_parent} custNameStatement={location.state?.data.custName} custAccountStatement={location.state?.data.customerCode} invoiceState={location.state?.data.invoiceFromParent} />} fileName={`exclusivefamilyllc_order_${location.state?.data.invoiceFromParent}`}>
                                {
                                    ({ loading }) => loading ? <button >loading..</button> : <button>Download PDF</button>
                                }
                            </PDFDownloadLink>
                            :
                            <span>loading PDF</span>
                        }
                    </div>

                    <PDFViewer className='mt-4 ViewPDFFile-pdfviewer' showToolbar={false}>
                        <MyDocument listOfStatement={location.state?.data.data_set_from_parent} custNameStatement={location.state?.data.custName} custAccountStatement={location.state?.data.customerCode} invoiceState={location.state?.data.invoiceFromParent} />
                    </PDFViewer>

                </div>

            </div>

        </div>


    )
}

export default ViewPDFFile;